import styled from "styled-components";

const GoogleMapWrapper = styled.div`
    height: 100%;
    width: 100%;
    border: solid 1px #a6a6a6;
`;

export default GoogleMapWrapper;



// WEBPACK FOOTER //
// ./components/misc/GoogleMapWrapper.jsx